
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class OnboardingTabText extends Vue {

    @Prop({})
    public readonly params!: any;
}
